module.exports = __webpack_public_path__ + "img/03uni-urushi.5962e8f4.png";